import { provideIntoWindow } from '@b2c/core/app/default/provide-into-window.js';
provideIntoWindow('$_VERSION', { version: '1.0.173-1.0.289' });